module.exports = __webpack_public_path__ + "img/6.268b8c09.png";